import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatSelectModule, MatSlideToggleModule } from '@angular/material';

import { DbmAdditionalOptionsComponent } from './dbm-additional-options.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        MatSelectModule,
        MatSlideToggleModule
    ],
    declarations: [DbmAdditionalOptionsComponent],
    entryComponents: [DbmAdditionalOptionsComponent],
    exports: [DbmAdditionalOptionsComponent]
})
export class DbmAdditionalOptionsModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/components/dbm-components/dbm-additional-options/dbm-additional-options.module.ts